import { useContext, useMemo } from 'react';
import { ExperienceContext } from '@thd-nucleus/experience-context';

const useAdditionalSearchParams = ({
  askForSponsored = false,
  hasSponsoredSorts = true,
  deliveryZip = null,
  showProducts = false,
  skipSpellCheck = false,
  isPEP = false,
  shouldSkipUntilLocalized = false,
  isStoreLocalized
} = {}) => {
  const ctx = useContext(ExperienceContext);
  const { cookie, customer } = ctx;

  const additionalSearchParams = useMemo(() => {
    const params = {};
    if (shouldSkipUntilLocalized) {
      if (customer?.svocId) {
        params.svocID = customer.svocId;
      }
      return params;
    }

    if (isPEP) {
      params.sponsored = true;
    }

    if (cookie?.adobeCookie?.MCMID && askForSponsored && hasSponsoredSorts) {
      params.sponsored = true;
      params.mcvisId = cookie.adobeCookie.MCMID;
    }

    if (showProducts) {
      params.plp = true;
    }

    if (skipSpellCheck) {
      params.skipSpellCheck = skipSpellCheck;
    }

    if (deliveryZip) {
      params.deliveryZip = deliveryZip;
    }

    if (customer?.svocId) {
      params.svocID = customer?.svocId;
    }

    if (typeof window !== 'undefined' && isStoreLocalized) {
      const THDCustomer = window.THDCustomer?.default || {};
      if (Object.keys(THDCustomer).length !== 0) {
        if (THDCustomer.svocID) {
          params.svocID = THDCustomer.svocID;
        }
        if (THDCustomer.mcvisID && !params.mcvisId) {
          params.mcvisId = THDCustomer.mcvisID;
        }
      }
    }
    return params;
  }, [
    shouldSkipUntilLocalized,
    askForSponsored,
    hasSponsoredSorts,
    deliveryZip,
    showProducts,
    skipSpellCheck,
    cookie?.adobeCookie?.MCMID,
    customer?.svocId
  ]);

  return additionalSearchParams;
};

export default useAdditionalSearchParams;